<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <div class="ma-0">
        <v-card elevation="6">
          <v-slide-x-reverse-transition>
            <v-alert type="success" class="alert" v-if="alert_success === true">เปลี่ยนสถานะเรียบร้อย !</v-alert>
          </v-slide-x-reverse-transition>
          <div class="pa-4">
            <v-card-text>
              รายการใบเสนอราคา
            </v-card-text>
            <v-divider/>
            <v-tabs grow color="#8cc63e">
              <v-tab @click="page(0)" style="font-size: 18px">ใบเสนอราคา (ขายปลีก)</v-tab>
              <v-tab @click="page(1)" style="font-size: 18px">ใบเสนอราคา (ขายส่ง)</v-tab>
            </v-tabs>
            <v-divider/>
            <div class="pa-2">
              <div v-if="loading_data === true">
                <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                  <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                </v-sheet>
              </div>
              <div v-else>
                <v-data-table :headers="headers" :items="data_list" :footer-props="footer_Props" mobile-breakpoint="0">
                  <template slot="item" slot-scope="dataDetail">
                    <tr>
                      <td>{{ dataDetail.item.order_code }}</td>
                      <td>{{ dataDetail.item.created_at }}</td>
                      <td>{{ dataDetail.item.customer_name }}</td>
                      <td>{{ dataDetail.item.total }}</td>
<!--                      <td>-->
<!--                        <v-btn v-if="dataDetail.item.status === 0 && title_add === 0" small height="42" style="font-size: 16px" @click="sellProduct(dataDetail.item.order_code)" class="grad-warning-bg white&#45;&#45;text mr-1 mb-1" title="แก้ไข">-->
<!--                          กำลังดำเนินการ-->
<!--                        </v-btn>-->
<!--                        <v-btn v-else-if="dataDetail.item.status === 0 && title_add === 1" small height="42" style="font-size: 16px" @click="sellProductWholesale(dataDetail.item.order_code)" class="grad-warning-bg white&#45;&#45;text mr-1 mb-1" title="แก้ไข">-->
<!--                          กำลังดำเนินการ-->
<!--                        </v-btn>-->
<!--                        <div v-else-if="dataDetail.item.status === 2" style="color: #8cc63e">ขายแล้ว</div>-->
<!--                      </td>-->
                      <td class="pa-3">
                        <v-btn small height="42" @click="getDetailsShop(dataDetail.item.order_code)" class="grad-success-bg white--text mr-1 mb-1" title="ดูรายละเอียด">
                          <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
        </v-card>
      </div>
      <v-overlay :value="overlay" class="z_index">
        <div class="text-center">
          <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="#86bc3a"
          ></v-progress-circular>
          <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
        </div>
      </v-overlay>
    </div>
  </div>
</template>

<script>
import {HTTP} from "@/axios";
import Swal from "sweetalert2";
import {diffDateTH} from "@/js/handler";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Quotation_web_site",
  data() {
    return {
      loading_page: false,
      loading_data: false,
      alert_success: false,
      title_add: 0,
      tab_list: 1,
      overlay: false,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      headers: [],
      data_list: [],
    }
  },
  methods: {
    async page(type) {
      this.title_add = type
      if (this.title_add === 0) {
        this.headers = [
          {
            text: 'เลขที่',
            value: 'order_code',
            fixed: true,
            width: '200px',
          },
          {
            text: 'วันที่',
            value: 'created_at',
            fixed: true,
            width: '150px',
          },
          {
            text: 'ลูกค้า',
            value: 'customer_name',
            fixed: true,
            width: '220px',
          },
          {
            text: 'ยอด',
            value: 'total',
            fixed: true,
            width: '150px',
          },
          // {
          //   text: 'สถานะ',
          //   value: 'status',
          //   fixed: true,
          //   width: '180px',
          // },
          {
            text: 'จัดการ',
            value: '',
            sortable: false,
            fixed: true,
            width: '270px',
          },
        ]
        this.get_retail_data()
      }
      else if (this.title_add === 1) {
        this.headers = [
          {
            text: 'เลขที่',
            value: 'order_code',
            fixed: true,
            width: '200px',
          },
          {
            text: 'วันที่',
            value: 'created_at',
            fixed: true,
            width: '150px',
          },
          {
            text: 'ลูกค้า',
            value: 'customer_name',
            fixed: true,
            width: '220px',
          },
          {
            text: 'ยอด',
            value: 'total',
            fixed: true,
            width: '150px',
          },
          // {
          //   text: 'สถานะ',
          //   value: 'status',
          //   fixed: true,
          //   width: '180px',
          // },
          {
            text: 'จัดการ',
            value: '',
            sortable: false,
            fixed: true,
            width: '270px',
          },
        ]
        this.get_quotation()
      }
    },
    get_retail_data() {
      this.loading_data = true
      HTTP.post('/quotations/quotationretailall')
          .then((res) => {
            if (res.data.success === true) {
              this.loading_data = false
              this.data_list = res.data.object
            }
          })
    },
    get_quotation() {
      this.loading_data = true
      HTTP.post('/quotations/quotationwholesaleall', )
          .then((res) => {
        if (res.data.success === true) {
          this.loading_data = false
          this.data_list = res.data.object
        }
      })
    },
    diff_dateTH: function (value) {
      return diffDateTH(value)
    },
    sellProduct(id) {
      Swal.fire({
        title: 'คุณต้องการดำเนินการต่อหรือไม่ ?',
        text: 'หากดำเนินการต่อสินค้าจะถูกเปลี่ยนสถานะเป็น ขายแล้ว',
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((res) => {
        if (res.isConfirmed === true) {
          this.overlay = true
          HTTP.post('/quotations/quotationretailsuccess', {
            order_code: id,
            user_id: this.$store.state.userDetail.id,
            user_name: this.$store.state.userDetail.name,
          }).then((res) => {
            if (res.data.success === true) {
              this.overlay = false
              this.page(0)
            }
          })
        }
      })
    },
    sellProductWholesale(id) {
      Swal.fire({
        title: 'คุณต้องการดำเนินการต่อหรือไม่ ?',
        text: 'หากดำเนินการต่อสินค้าจะถูกเปลี่ยนสถานะเป็น ขายแล้ว',
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((res) => {
        if (res.isConfirmed === true) {
          this.overlay = true
          HTTP.post('/quotations/quotationwholesalesuccess', {
            order_code: id,
            user_id: this.$store.state.userDetail.id,
            user_name: this.$store.state.userDetail.name,
          }).then((res) => {
            if (res.data.success === true) {
              this.overlay = false
              this.page(1)
            }
          })
        }
      })
    },
    getDetailsShop(id) {
      const type = this.title_add
      this.$router.push('/stock/quotation/quotationdetailshop/' + id + '/' + type)
    },
  },
  mounted() {
    this.page(0)
  }
}
</script>

<style scoped>

</style>
